import { useCallback } from 'react';

import { useUpdateConsignmentLineMutation } from '../api/consignmentsApi';
import type { ConsignmentLineUpdateParams, ConsignmentLineWriteRequest, ConsignmentLineDetailResponse } from './types';

export interface UseUpdateConsignmentLineOptions {
  onSuccess?: (data: ConsignmentLineDetailResponse) => void;
  onError?: (error: unknown) => void;
}

export const useUpdateConsignmentLine = (options?: UseUpdateConsignmentLineOptions) => {
  const [updateConsignmentLine, { isLoading, isSuccess, isError, error, data }] = useUpdateConsignmentLineMutation();

  const handleUpdate = useCallback(
    async (params: ConsignmentLineUpdateParams, data: ConsignmentLineWriteRequest) => {
      try {
        const response = await updateConsignmentLine({
          params,
          data
        }).unwrap();

        options?.onSuccess?.(response);
        return response;
      } catch (error) {
        options?.onError?.(error);
        throw error;
      }
    },
    [updateConsignmentLine, options]
  );

  return {
    updateConsignmentLine: handleUpdate,
    isLoading,
    isSuccess,
    isError,
    error,
    data
  };
};
